import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Text } from '@uhg-abyss/web/ui/Text';

export const StyledFAQContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '24px',
});

export const StyledSmartChoiceMessage = styled('div', {
  paddingTop: '16px',
  color: '#4B4D4F',
  fontWeight: '400',
  fontSize: '18px',
});

export const StyledSetPreferencesButton = styled(Button, {
  '&.abyss-button-root': {
    width: '100%',

    // Media query for smaller screens
    '@media (min-width: 465px)': {
      marginTop: '32px', // Reduced margin for tablets
      marginBottom: '24px',
    },

    // Media query for very small screens
    '@media (max-width: 464px)': {
      margin: '16px 0px', // Further reduced margin for mobile devices
    },
  },
});

export const StyledSmartChoiceText = styled(Text, {
  '&.abyss-text-root': {
    color: '#BD5000',
    fontWeight: '700',
    lineHeight: '1.5',
    fontSize: '18px',
  },
});

export const StyledContentWrapper = styled('div', {
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingBottom: '16px',

  // Conditional styles for mobile screens
  '@media (max-width: 464px)': {
    paddingLeft: '0px',
    paddingRight: '0px',
    paddingBottom: '0px',
  },
});

export const drawerStyles = {
  drawerSize: 492,
  drawerPosition: 'right',
};
